// "Credits are low": 20% of the month's credits or less are left (or the plan has none). The Ask AI chat, AI Agents and AI Studio offer
// "Buy credits" only then; at any other time a customer buys from the Subscription page -> "Buy Credits" tab.
export const LOW_CREDITS_SHARE = 0.2;

export const isLowCredits = (c) => !!c && Number(c.remaining || 0) <= Math.max(0, Number(c.limit || 0) * LOW_CREDITS_SHARE);
